"use client";
import React from "react";
import { HeaderTextImageButtonSection } from "@/src/api/fetchHomeSections/types";
import { useFindSection } from "@/src/hooks/useFindSection";
import { HomeSectionProps } from "@/src/types/home-section-props";
import {
  AnimatedImage,
  AnimatedText,
  HomeSectionContainer,
} from "@/src/components";
import { useParseLinks } from "@/src/hooks/useParseLinks";
import useModal from "@/src/hooks/useModal";
import ContactUs from "@/src/components/ContactUs";
import ReusableButtons from "@/src/components/ReusableButtons/ReusableButtons";

const Sustainability: React.FC<HomeSectionProps> = ({ data }) => {
  const foundSection = useFindSection(data, "header+text+image+button");
  const section = foundSection as HeaderTextImageButtonSection | undefined;

  const { parseLinks } = useParseLinks();
  const {
    isOpen: isContactModalOpen,
    openPopup: openContactModal,
    closePopup: closeContactModal,
  } = useModal();

  if (!section) return null;

  return (
    <HomeSectionContainer>
      <AnimatedText direction="left">
        <p className="home-section-title">{section.header}</p>
        <p className="home-section-text">
          {parseLinks(section.suptitile || "")}
        </p>

        {section.buttons && (
          <ReusableButtons buttons={section.buttons} onContactClick={openContactModal} />
        )}
      </AnimatedText>

      <AnimatedImage
        src={section.image.url}
        alt={section.image.title || "Our Credentials"}
        direction="right"
        width={750}
        height={440}
      />

      <ContactUs isOpen={isContactModalOpen} onClose={closeContactModal} />
    </HomeSectionContainer>
  );
};

export default Sustainability;
